import { render, staticRenderFns } from "./Finance.vue?vue&type=template&id=39908ec6&scoped=true"
import script from "./Finance.vue?vue&type=script&lang=js"
export * from "./Finance.vue?vue&type=script&lang=js"
import style0 from "./Finance.vue?vue&type=style&index=0&id=39908ec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39908ec6",
  null
  
)

export default component.exports